module.exports = __webpack_public_path__ + "img/huanjing.feeccb03.png";